import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { authorizationRoutes } from './authorization.router';
import { AuthService } from '../services/auth.service';
import { UsersService } from '../services/crud/users.service';
import { RoleService } from '../services/role.service';
import { IMaskModule } from 'angular-imask';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatInputModule} from '@angular/material/input';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatButtonModule} from '@angular/material/button';
import {EnterTwoFactorComponent} from './login/enter-two-factor/enter-two-factor.component';
import {A11yModule} from '@angular/cdk/a11y';


@NgModule({
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    ConfirmEmailComponent,
    ResetPasswordComponent,
    EnterTwoFactorComponent,
  ],
  entryComponents: [
  ],
    imports: [
        FormsModule,
        CommonModule,
        MatIconModule,
        MatCardModule,
        MatFormFieldModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSnackBarModule,
        FlexLayoutModule,
        MatButtonModule,
        IMaskModule,
        RouterModule.forChild(authorizationRoutes),
        A11yModule,
    ],
  providers: [
    AuthService,
    UsersService,
    RoleService,
  ],
})
export class AuthorizationModule { }
